export type HomeViewId = "visao-geral" | "obras-em-andamento";

export interface HomeViewDefinition {
  id: HomeViewId;
  label: string;
  testId: string;
}

/**
 * AC2 — a Tela Inicial oferece exatamente estas duas visões. "Obras Futuras" e
 * "Obras Finalizadas" aparecem no protótipo, mas seguem em backlog e não são
 * exibidas nem oferecidas como opção (RN05/RN06).
 */
export const HOME_VIEWS: HomeViewDefinition[] = [
  { id: "visao-geral", label: "Visão Geral", testId: "home-view-visao-geral" },
  {
    id: "obras-em-andamento",
    label: "Obras em Andamento",
    testId: "home-view-obras-em-andamento",
  },
];

/** AC1 — a Home abre com a Visão Geral selecionada. */
export const HOME_DEFAULT_VIEW: HomeViewId = "visao-geral";

/**
 * Ponto de quebra do protótipo responsivo, o mesmo do layout autenticado
 * (`layout.module.scss`). Abaixo dele a barra de abas dá lugar à lista suspensa
 * do protótipo "Início / Visão Geral — Mobile"; as duas visões continuam
 * disponíveis nas duas larguras.
 */
export const HOME_NARROW_QUERY = "(max-width: 768px)";
